// Módulo: Conciliação Bancária (Bootstrap Loader)
// Carrega os submódulos da nova arquitetura V3.

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};

const loadSchrodingerScript = (src) => new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
});

window.FazendaRP.Pages.conciliacao = {
    // Ponto de entrada chamado pelo roteador da página
    render: async function (container) {
        container.innerHTML = '<div style="text-align:center; padding:50px; color:#6b7280;"><i class="fas fa-circle-notch fa-spin fa-2x"></i><br><br>Carregando Sherlock V3...</div>';

        try {
            console.log("Bootstrap: Carregando módulos...");
            const basePath = 'js/pages/financeiro/conciliacao/';

            const version = '5.1.0'; // Updated: debug code removed
            await loadSchrodingerScript(basePath + 'parsers.js?v=' + version);
            await loadSchrodingerScript(basePath + 'data.js?v=' + version);
            await loadSchrodingerScript(basePath + 'match.js?v=' + version);
            await loadSchrodingerScript(basePath + 'ui.js?v=' + version);
            await loadSchrodingerScript(basePath + 'core.js?v=' + version);

            console.log("Bootstrap: Módulos carregados.");

            // O Core é registrado em window.FazendaRP.Pages.conciliacao.core
            const Core = window.FazendaRP.Pages.conciliacao.core;

            if (!Core) throw new Error("Core module not found!");

            // Mapeia métodos globais para que o HTML gerado (onclick) funcione
            // Copia todos os métodos do Core para "conciliacao" (este objeto)
            // Isso permite que chamadas como window.FazendaRP.Pages.conciliacao.unlinkItem() funcionem
            Object.keys(Core).forEach(key => {
                if (typeof Core[key] === 'function') {
                    this[key] = Core[key].bind(Core);
                }
            });

            // Redireciona render
            await Core.init(container);

        } catch (e) {
            console.error("Erro fatal na conciliação:", e);
            container.innerHTML = `<div style="color:#ef4444; text-align:center; padding:20px;">
                <h3>Erro ao carregar módulo</h3>
                <p>${e.message}</p>
            </div>`;
        }
    }
};
